import { THEMES } from '../../../../src/client/theme.js';
import { api } from '../api.js';
import { escapeHtml } from '../../../../src/shared/escape-html.js';
import { runSensitiveAdminMutation } from '../admin-security.js';

let _rendered = false;

export async function render() {
  if (_rendered) return;
  _rendered = true;

  const grid   = document.getElementById('admin-themes-grid');
  const status = document.getElementById('admin-themes-status');
  if (!grid) return;

  grid.innerHTML = '<div class="admin-loading">Loading themes…</div>';

  let features;
  try {
    features = await api.get('/api/admin/features');
  } catch {
    grid.innerHTML = '<div class="admin-loading">Failed to load theme flags.</div>';
    return;
  }

  grid.innerHTML = '';

  for (const theme of THEMES) {
    const flagName  = `theme:${theme.id}`;
    const isDefault = theme.id === 'default';
    const locked    = isDefault || theme.seedOnly === true;
    const noteId    = theme.seedOnly ? `admin-theme-note-${theme.id}` : '';
    const enabled   = features[flagName] !== false;

    const card = document.createElement('div');
    card.className = `admin-theme-card ${enabled ? 'enabled' : 'disabled'}`;
    card.innerHTML = `
      <div class="admin-theme-preview ${escapeHtml(theme.thumbClass || '')}" data-theme-preview="${escapeHtml(theme.id)}" aria-hidden="true"></div>
      <div class="admin-theme-body">
        <div class="admin-theme-head">
          <span class="admin-theme-name">${escapeHtml(theme.label)}</span>
          ${isDefault ? '<span class="admin-module-badge">Always On</span>' : ''}
        </div>
        <div class="admin-theme-desc">${escapeHtml(theme.description || '')}</div>
        ${noteId ? `<div class="admin-theme-desc" id="${escapeHtml(noteId)}">Stored in the database. This screen can't change it until the next requalification.</div>` : ''}
      </div>
      <label class="admin-toggle">
        <input
          type="checkbox"
          data-theme="${escapeHtml(theme.id)}"
          ${enabled ? 'checked'  : ''}
          ${locked  ? 'disabled' : ''}
          ${noteId  ? `aria-describedby="${escapeHtml(noteId)}"` : ''}
          aria-label="Enable ${escapeHtml(theme.label)}">
        <span class="admin-toggle-slider"></span>
      </label>
    `;
    grid.appendChild(card);
  }

  grid.querySelectorAll('input[data-theme]').forEach((input) => {
    input.addEventListener('change', async (e) => {
      const themeId = e.target.dataset.theme;
      const value   = e.target.checked;
      const flagName = `theme:${themeId}`;

      status.textContent = 'Saving…';
      status.className = 'admin-status saving';
      try {
        const completed = await runSensitiveAdminMutation({
          actionLabel: `change the ${flagName} feature flag`,
          mutate: (reason) => api.patch('/api/admin/features', {
            updates: { [flagName]: value },
            reason,
          }),
        });
        if (!completed) {
          e.target.checked = !value;
          status.textContent = '';
          status.className = 'admin-status';
          return;
        }

        const card = e.target.closest('.admin-theme-card');
        card.classList.toggle('enabled', value);
        card.classList.toggle('disabled', !value);

        status.textContent = value ? `${themeId} enabled.` : `${themeId} disabled.`;
        status.className = 'admin-status success';
      } catch (err) {
        e.target.checked = !value;
        status.textContent = `Error: ${err.message}`;
        status.className = 'admin-status error';
      }
      setTimeout(() => { status.textContent = ''; status.className = 'admin-status'; }, 4000);
    });
  });
}
